import 'common/scripts/polyfills';
import {
    fixPopupHeader,
    initCallbackForm,
    initCallbackPopups,
    initMobileMenu
} from 'common/scripts/common';
import App from './App.vue';
import router from './router';
import store from './store';
import Vue from 'vue';

Vue.config.productionTip = false;

Vue.prototype.$appOptions = {
    overlay: {
        default: 0.3,
        hover  : 0.6,
        floor  : 0.3
    }
};

const el = '#visual';
const visualEl = document.querySelector(el);
const complexId = visualEl ? visualEl.dataset.complexId || false : false;

router.beforeEach((to, from, next) => {
    if (!to.params.hasOwnProperty('complexId') && complexId) {
        to.params.complexId = complexId;
    }
    next();
});

new Vue({
    router,
    store,
    render: (h) => {
        return h(App);
    }
}).$mount(el);

// Поведение меню
const headerWrap = document.querySelector('.j-header');
const burgerMenuSelector = document.querySelector('.j-burger-menu');

if (burgerMenuSelector) {
    initMobileMenu(burgerMenuSelector, headerWrap);
}

// Попапы обратной связи и инциализация формы
const popupLinks = Array.from(document.querySelectorAll('.j-popup-callback-call'));

if (popupLinks.length) {
    initCallbackPopups(popupLinks);
    initCallbackForm();
}

// При открытии попапа сдвигаем шапку на ширину сколл-бара.
fixPopupHeader(headerWrap);

// Подключение GTM из скриптов
const scriptHead = document.createElement('script');

scriptHead.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KLDKSDN');`;

const scrtiptBody = document.createElement('noscript');

scrtiptBody.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KLDKSDN"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const head = document.getElementsByTagName('head')[0];
const body = document.getElementsByTagName('body')[0];

head.insertBefore(scriptHead, head.lastChild);
body.insertBefore(scrtiptBody, body.lastChild);
